import React from 'react'
import ReactDOM from 'react-dom'
import { Router, browserHistory } from 'react-router'
import { Provider } from 'react-redux'

import route from './routes'
import configureStore from './stores/configureStore'

const store = configureStore(window.INITIAL_STATE)

window.digitalData = Object.assign({}, window.digitalData, {
  page: window.digitalData && window.digitalData.page ? window.digitalData.page : {},
  user: window.digitalData && window.digitalData.user ? window.digitalData.user : [{}]
})

const app = (
  <Provider store={store}>
    <Router history={browserHistory}>
      { route(store) }
    </Router>
  </Provider>
)

ReactDOM.hydrate(app, document.getElementById('root'))
